export default "__VITE_ASSET__UrDvUvRJ__"